import * as React from 'react';
import { Tooltip, ToggleButton, ToggleButtonGroup, Box } from '@mui/material';


export default function RadioIconButtonGroup({
    hook, setHook, buttonValues, buttonIcons, buttonDisableds, tooltipValues,
}) {
    return (
        <ToggleButtonGroup
            exclusive
            orientation="horizontal"
            aria-label="Alignment"
            name="alignment"
            variant="outlined"
            value={hook}
            onChange={(event) => setHook(event.target.value)}
            sx={{ display: 'inline-flex' }}
        >
        {/* <RadioGroup
            orientation="horizontal"
            aria-label="Alignment"
            name="alignment"
            variant="outlined"
            value={hook}
            onChange={(event) => setHook(event.target.value)}
            sx={{ display: 'inline-flex' }}
        > */}
        {buttonValues.map((item) => (
            // <Box
            //     key={item}
            //     sx={(theme) => ({
            //         position: 'relative',
            //         display: 'flex',
            //         justifyContent: 'center',
            //         alignItems: 'center',
            //         width: `${100 / buttonValues.length}%`,
            //         minWidth: 50,
            //         height: 50,
            //         // '&:not([data-first-child])': {
            //         // borderLeft: '1px solid',
            //         // borderColor: 'divider',
            //         // },
            //         // [`&[data-first-child] .${radioClasses.action}`]: {
            //         // borderTopLeftRadius: `calc(${theme.vars.radius.sm} - 1px)`,
            //         // borderBottomLeftRadius: `calc(${theme.vars.radius.sm} - 1px)`,
            //         // },
            //         // [`&[data-last-child] .${radioClasses.action}`]: {
            //         // borderTopRightRadius: `calc(${theme.vars.radius.sm} - 1px)`,
            //         // borderBottomRightRadius: `calc(${theme.vars.radius.sm} - 1px)`,
            //         // },
            //     })}
            // >
            <Tooltip title={tooltipValues[item]}>         
                <ToggleButton
                    value={item}
                    disableIcon
                    overlay
                    label={
                        buttonIcons[item]
                    }
                    disabled={buttonDisableds[item]}
                    sx={{
                        width: `${100 / buttonValues.length}%`,
                        minWidth: 50,
                        height: 50,
                    }}
                >
                    {buttonIcons[item]}
                </ToggleButton>
            </Tooltip>
            // </Box>
        ))}
        {/* </RadioGroup> */}
        </ToggleButtonGroup>
    );
}
